import React from "react";
import { Link } from "react-router-dom";
import AboutImg2 from "../assets/images/sidom/fotos/Nosotros/logo.svg";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import Team from "../components/team";
import StatsCards from "../components/StatsCards";
import "../../node_modules/react-modal-video/css/modal-video.css";
import Navbar from "../components/navbar";
import VisionMissionValues from "../components/VisionMissionValues";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function AboutUs() {
  // const [isOpen, setOpen] = useState(false);
  return (
    <HelmetProvider>
      <div className="bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-light">
        <Helmet>
          <title>Sobre Nosotros | SIDOM</title>
          <meta
            name="description"
            content="Conoce la historia, misión y visión de SIDOM, líder en soluciones tecnológicas para comercio exterior y logística internacional."
          />
          <meta property="og:title" content="Sobre Nosotros | SIDOM" />
          <meta
            property="og:description"
            content="Conoce la historia, misión y visión de SIDOM, líder en soluciones tecnológicas para comercio exterior y logística internacional."
          />
          <meta
            property="og:image"
            content="https://sidomsuite.com/wp-content/themes/sidom-pay/assets/about-hiro.jpg"
          />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <Navbar />

        <section className="relative  py-32 lg:py-40 bg-[url('https://sidomsuite.com/wp-content/themes/sidom-pay/assets/about-hiro.jpg')] bg-no-repeat bg-top bg-cover">
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/80 to-black"></div>
          <div className="container relative">
            <div className="grid grid-cols-1 pb-8 text-center mt-10">
              <h3 className="text-3xl leading-normal font-medium text-white">
                Transformamos la gestión del comercio exterior con tecnología
                avanzada
              </h3>
            </div>
          </div>

          <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
            <ul className="tracking-[0.5px] mb-0 inline-block">
              <li className="inline-block capitalize text-[14px] duration-500 ease-in-out text-white/50 hover:text-white">
                <Link to="/">SIDOM</Link>
              </li>
              <li className="inline-block text-[18px] text-white/50 mx-0.5 ltr:rotate-0 rtl:rotate-180">
                <i className="mdi mdi-chevron-right align-middle"></i>
              </li>
              <li
                className="inline-block capitalize text-[14px] duration-500 ease-in-out text-white"
                aria-current="page"
              >
                Nosotros
              </li>
            </ul>
          </div>
        </section>
        <div className="relative">
          <div className="shape absolute sm:-bottom-px -bottom-[2px] start-0 end-0 overflow-hidden z-1 text-white dark:text-slate-900">
            <svg
              className="w-full h-auto scale-[2.0] origin-top"
              viewBox="0 0 2880 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>

        <section className="relative md:py-24 py-16">
          <div className="container ">
            <div className="grid grid-cols-1 md:grid-cols-5 gap-10 items-center">
              <div className="md:col-span-2 w-full flex flex-col items-center justify-center">
                <img
                  src={AboutImg2}
                  className="rounded-lg h-full w-[200px] relative"
                  alt=""
                />
                <p className="mb-4 text-base leading-[1.3] text-left font-medium">
                  <strong>SIDOM </strong>surge de una historia de sueños
                  audaces, perseverancia y una visión global. Fundada por tres
                  emprendedores con una pasión inquebrantable por revolucionar
                  el comercio exterior, nuestra empresa nació en un modesto
                  galpón en Argentina, impulsada por un propósito claro: ofrecer
                  una solución integral e innovadora para la gestión de la
                  logística y el comercio internacional.
                </p>
              </div>
              <div className="md:col-span-3 w-full">
                <div className="lg:ms-7">
                  <p className="text-sidom-dark leading-[1.3] text-base text-left  dark:text-sidom-light mx-auto">
                    Desde el comienzo, sabíamos que el éxito en el comercio
                    global requiere algo más que tecnología avanzada. Requiere
                    entender y abrazar las complejidades únicas de cada cliente.
                    Fue nuestra obsesión por el cliente lo que nos llevó a
                    desarrollar un enfoque personalizado, mucho antes de que
                    este concepto se convirtiera en una tendencia. Cada desafío
                    que enfrentaron nuestros clientes se convirtió en una
                    oportunidad para innovar y automatizar, creando un producto
                    que no solo se adapta, sino que se anticipa a las
                    necesidades cambiantes del mercado. Hoy, después de
                    <strong> 20 años </strong>de liderazgo y presencia en
                    <strong> 14 países,</strong>
                    <strong> SIDOM</strong> no sólo ha cumplido su promesa, sino
                    que la ha elevado a nuevas alturas. Nuestra suite de
                    soluciones es única por su capacidad para integrarse
                    perfectamente con el ecosistema del comercio global de todo
                    el mundo y adaptarse a los procesos específicos de cada
                    empresa. Este enfoque flexible y nuestra capacidad de
                    personalización nos han convertido en el aliado preferido
                    para las principales empresas globales, así como para marcas
                    regionales en expansión. El mundo del comercio internacional
                    está en constante evolución, y en <strong>SIDOM</strong> ,
                    estamos comprometidos a ser el socio que guía a las empresas
                    hacia el futuro. Nuestro software no solo resuelve
                    problemas, sino que anticipa desafíos y ofrece una
                    plataforma escalable para crecer junto a nuestros clientes.
                    Somos el puente entre la ambición regional y el éxito
                    global. Únete a nosotros y descubre cómo, con la misma
                    pasión con la que surgimos y nos consolidamos como la
                    solución Saas número 1 en el mercado, podemos acompañarte en
                    tu viaje hacia la automatización y eficientización de tu
                    cadena logística en todo el mundo, transformando la forma en
                    que manejas el comercio global y elevando tu negocio a
                    nuevas alturas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <VisionMissionValues />
        <StatsCards />

        <Team />

        <Footer />
        <Switcher />
      </div>
    </HelmetProvider>
  );
}
